export default "__VITE_ASSET__BIyjz_al__"